import { styled, Button } from '@mui/material'

export const LinkButton = styled(Button)({
  textDecoration: 'underline',
  minWidth: 16,
  minHeight: 'auto',
  fontSize: '0.875rem',
  fontWeight: '700',
  lineHeight: '1.5rem',
})
